import React from "react";
import {
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaEnvelope,
  FaHeart,
} from "react-icons/fa";
import { contactData } from "../data/portfolioData";  // ← IMPORT
import Logo from "../assets/images/logo.svg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <FaGithub />, href: contactData.socialLinks.github, label: "GitHub" },
    { icon: <FaLinkedin />, href: contactData.socialLinks.linkedin, label: "LinkedIn" },
    { icon: <FaTwitter />, href: "#", label: "Twitter" },
    { icon: <FaEnvelope />, href: `mailto:${contactData.email}`, label: "Email" },
  ];

  return (
    <footer className="relative overflow-hidden pt-20 pb-10">
      {/* Background with light/dark mode */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-100 to-white dark:from-gray-900 dark:to-gray-950">
        <div className="absolute inset-0 bg-cyber-grid opacity-5" />
        <div className="absolute top-0 left-0 w-64 h-64 bg-cyber-green/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-cyber-purple/5 rounded-full blur-3xl" />
      </div>

      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand Section */}
          <div>
             <a href="#home" className="flex items-center space-x-2">
            <div
              role="img"
              aria-label="Logo"
              className="w-12 h-10 gradient-text-mask"
              style={{
                WebkitMaskImage: `url(${Logo})`,
                maskImage: `url(${Logo})`,
                WebkitMaskSize: 'contain',
                maskSize: 'contain',
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                maskPosition: 'center',
              }}
            />
          </a>
            <p className="text-gray-600 dark:text-gray-400 mt-6">
              Creating secure, beautiful, and functional digital experiences.
              Bridging cybersecurity, development, and design.
            </p>
            
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6 gradient-text">
              Quick Links
            </h4>
            <div className="grid grid-cols-2 gap-4">
              {[
                "Home",
                "Projects",
                "Experience",
                "Education",  
                "Contact",
              ].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  className="text-gray-600 dark:text-gray-400 hover:text-cyber-green transition-colors duration-300 
                           hover:translate-x-2 transform"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          {/* Contact Info - USING DATA */}
          <div>
            <h4 className="text-xl font-bold mb-6 gradient-text">
              Get In Touch
            </h4>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-lg bg-cyber-green/10 flex items-center justify-center">
                  <FaEnvelope className="text-cyber-green" />
                </div>
                <div>
                  <p className="text-gray-600 dark:text-gray-400">Email</p>
                  <a
                    href={`mailto:${contactData.email}`}
                    className="text-gray-900 dark:text-gray-300 hover:text-cyber-green"
                  >
                    {contactData.email}
                  </a>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-lg bg-cyber-blue/10 flex items-center justify-center">
                  <span className="text-cyber-blue">📍</span>
                </div>
                <div>
                  <p className="text-gray-600 dark:text-gray-400">Location</p>
                  <p className="text-gray-900 dark:text-gray-300">
                    {contactData.location}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-300 dark:border-white/10 my-5" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 dark:text-gray-400">
            © {new Date().getFullYear()} Wais Nazari. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;